import { useSelector } from 'react-redux'

import * as selectors from '../graphQl.selectors'

export const useValidationErrors = () => useSelector(selectors.validationErrors)
